import { AuthLayout } from "@/components/shared/layouts/AuthLayout/AuthLayout";
import { SignUp } from "@/components/features/signup/SignUp/SignUp";
const SignUpPage = () => {
  return (
    <AuthLayout>
      <SignUp />
    </AuthLayout>
  );
};

export default SignUpPage;
